'use client'

// @ts-ignore
function gtag(command: string, ...args) {
    // @ts-ignore
    window.dataLayer.push(arguments)
}

export const isGoogleAnalyticsEnabled = (): boolean =>
    typeof window !== 'undefined' && window.location.hostname === 'circuitly.com'

if (isGoogleAnalyticsEnabled()) {
    // @ts-ignore
    window.dataLayer = window.dataLayer || []
    // @ts-ignore
    gtag('js', new Date())
    // page_view is sent manually on every route change by the GoogleAnalytics
    // component, so suppress the automatic first-load page_view here.
    // @ts-ignore
    gtag('config', 'GT-MJM4T87J', { send_page_view: false })
}

export default gtag
